import React from 'react';
import { useTranslation } from 'react-i18next';

interface ChartEmptyProps {
  height?: number;
}

const ChartEmpty: React.FC<ChartEmptyProps> = ({ height = 300 }) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center justify-center text-(--blue-4)"
      style={{ height }}
    >
      {t('analytics_no_data_for_period')}
    </div>
  );
};

export default ChartEmpty;
